module.exports = __webpack_public_path__ + "statics/img/3-5.3d72c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-5.png
// module id = QQ1V
// module chunks = 1